const UPDATES = [
  { id: 1, time: '10分钟前', tag: '更新', title: '《暗影猎手》第238话 - 终章决战篇上线', hot: true },
  { id: 2, time: '28分钟前', tag: '新番', title: '《星辰变·外传》第12话 - 全新篇章开启', hot: true },
  { id: 3, time: '1小时前', tag: '更新', title: '《都市灵异录》第156话 - 深夜探秘篇', hot: false },
  { id: 4, time: '2小时前', tag: '完结', title: '《恋爱方程式》全本完结 - 120话完整收录', hot: true },
  { id: 5, time: '3小时前', tag: '更新', title: '《剑道无双》第421话 - 剑圣降临篇', hot: false },
  { id: 6, time: '4小时前', tag: '新番', title: '《美食猎人》第89话 - 传说中的食材', hot: false },
  { id: 7, time: '5小时前', tag: '更新', title: '《末日求生录》第67话 - 避难所危机', hot: false },
  { id: 8, time: '6小时前', tag: '热门', title: '《绝世神医》第312话 - 妙手回春', hot: false },
  { id: 9, time: '7小时前', tag: '更新', title: '《机甲战神》第198话 - 最终兵器启动', hot: false },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            更新快讯
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            实时追踪全网漫画更新动态，不错过每一话精彩内容
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-primary-200">
            {UPDATES.map((item) => (
              <div key={item.id} className="relative mb-6 last:mb-0 group">
                <span className="absolute -left-[calc(2rem+5px)] top-1 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-100"></span>
                <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
                  <div className="flex items-center gap-2 flex-shrink-0">
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${
                      item.tag === '新番' ? 'bg-accent-100 text-accent-800' :
                      item.tag === '完结' ? 'bg-secondary-100 text-secondary-800' :
                      item.tag === '热门' ? 'bg-primary-100 text-primary-800' :
                      'bg-background-200 text-foreground-600'
                    }`}>
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.time}</span>
                  </div>
                  <div className="flex items-center gap-2 flex-1 min-w-0">
                    <span className="text-sm md:text-base text-foreground-800 font-medium truncate">{item.title}</span>
                    {item.hot && (
                      <span className="flex-shrink-0 text-[10px] px-1.5 py-0.5 rounded-full bg-primary-500/10 text-primary-600 font-semibold whitespace-nowrap">
                        HOT
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}